import { Paso0 } from '../interfaces/paso-0';
import { Paso1 } from '../interfaces/paso-1';
import { Paso1Login } from '../interfaces/paso-1-login';
import { Paso2 } from '../interfaces/paso-2';
import { Paso3 } from '../interfaces/paso-3';


export abstract class LocalStorageService {

  abstract getCurrentPage(): string;
  abstract setCurrentPage(page: string): void;

  abstract getPaso0(): Paso0;
  abstract setPaso0(data: Paso0): void;

  abstract getPaso1(): Paso1;
  abstract setPaso1(data: Paso1): void;

  abstract getPaso1Login(): Paso1Login;
  abstract setPaso1Login(data: Paso1Login): void;

  abstract getPaso2(): Paso2;
  abstract setPaso2(data: Paso2): void;
  abstract addPaso2(data: Paso2): void;

  abstract getPaso3(): Paso3;
  abstract setPaso3(data: Paso3): void;

  abstract resertApp();

}
